export default __webpack_public_path__ + "static/hw_ff_ky_040-b8ef3023e62d30e959912414240d2ef9.png";